import { withBemMod } from '@bem-react/core';
import { useComponentRegistry } from '@bem-react/di';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelDownload } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_download.css';

export interface ILevelTypeDownloadProps extends Omit<ILevelDownload, 'type'> {
    type?: 'download';
}

export const withLevelTypeDownload = withBemMod<ILevelTypeDownloadProps, ILevelProps>(
    cnLevel(),
    { type: 'download' },
    (BaseLevel: React.FC<ILevelProps>) => props => {
        const { Button } = useComponentRegistry('lego');

        const { imageSrc, title, description, buttonUrl, buttonText, ...otherProps } = props;

        return (
            <BaseLevel {...otherProps}>
                <>
                    {imageSrc && <img className={cnLevel('image')} src={imageSrc} alt={title} />}
                    <div className={cnLevel('info')}>
                        <HtmlContent className={cnLevel('title')} content={title} />
                        {description && (
                            <HtmlContent className={cnLevel('description')} content={description} />
                        )}
                        <Button
                            theme="action"
                            view="classic"
                            size="m"
                            type="link"
                            url={buttonUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            {buttonText}
                        </Button>
                    </div>
                </>
            </BaseLevel>
        );
    }
);
